<template>
  <div class="guarantee">
    <div class="container">
      <h3>动力保障</h3>
      <div class="icons">
        <el-card
          v-for="(item, index) in guaranteeAlbums"
          :key="index"
          style="width: 376px; height: 302.9px;text-align: center;justify-content: center;background-color: #ffffff;border-radius: 10px;"
          :style="{
            marginLeft: index == 0 ? '0px' : '20px'
          }"
          shadow="never"
          :body-style="{ padding: '0px' }"
        >
          <div>
            <img
              :src="item.url"
              alt
              style="width: 296px; height: 152px; margin-top: 40px;margin-bottom: 30px;"
            />
            <span
              style="font-size:1.125rem;color: #1A1A1A;font-weight: bolder;line-height: 1.75rem;text-align: center;display: block;margin-bottom: 15px;"
              >{{ item.title }}</span
            >
            <!-- <div
              v-html="item.desc"
              style="font-size:14px;line-height:1.375rem;color: #777777;"
            ></div> -->
          </div>
        </el-card>
      </div>
    </div>
  </div>
</template>

<style scoped>
.guarantee {
  text-align: center;
}
.container {
  width: 100%;
  height: 550px;
  margin-top: 50px;
  background-color: rgba(180, 214, 242, 0.2);
  display: inline-block;
}
.icons {
  display: flex;
  flex-flow: row;
  flex-wrap: nowrap;
  justify-content: center;
  text-align: center;
}

.el-card {
  border-radius: 10px;
}
h3 {
  font-size: 1.5rem;
  line-height: 36px;
  color: #1a1a1a;
  padding-top: 50px;
  padding-bottom: 50px;
}

span {
  line-height: 1.375rem;
  font-size: 0.875rem;
  color: #777777;
}
</style>

<script>
import { onActivated } from "vue";
export default {
  data() {
    return {
      msg: "动力保障",
      guaranteeAlbums: [
        {
          url: require("../assets/welfare/album01_0.png"),
          title: "五险一金",
          desc:
            "公司为所有员工缴纳五险一金<br/>（养老、医疗、工伤、失业、<br/>生育保险及住房公积金），<br/>并购买高额的商业补充保险<br/>（意外险、门诊险、定期寿险等）。"
        },
        {
          url: require("../assets/welfare/album01_1.png"),
          title: "免费体检",
          desc:
            "公司倡导“健康生活，快乐工作”，<br/>每年定期选取高端体检机构，<br/>免费为员工提供全面、正规、舒适的体检服务。"
        },
        // {
        //   url: require("../assets/welfare/album01_2.png"),
        //   title: "健身Club",
        //   desc:
        //     "我运动，我快乐。健身一小步，健康一大步。<br/>为了让员工更好地放松身心，<br/>公司为员工准备了五星级服务健身会所，每周每<br/>员工享受1次免费健身福利，体验健身器材、<br/>瑜伽、有氧舞蹈、健身操、游泳等锻炼。"
        // }
      ]
    };
  },
  onActivated() {}
};
</script>



// WEBPACK FOOTER //
// src/components/Guarantee.vue